// RO translations for Surplify.
// Maintained as a per-language file. See ../i18n.js for init logic.

const ro = {
  "app.title": "Surplify",
  "nav.home": "Acasa",
  "nav.search": "Cautare",
  "nav.watchlist": "Lista de urmarire",
  "nav.requests": "Cererile mele",
  "nav.dashboard": "Panou",
  "nav.admin": "Admin",
  "nav.import": "Import",
  "nav.login": "Autentificare",
  "nav.register": "Inregistrare",
  "nav.logout": "Deconectare",
  "material.request": "Solicita material",
  "material.addToWatchlist": "Adauga la urmarire",
  "material.removeFromWatchlist": "Sterge din urmarire",
  "status.reserved": "Rezervat",
  "status.pending": "In asteptare",
  "status.approved": "Aprobat",
  "status.rejected": "Respins",
  "status.completed": "Finalizat",
  "badge.groupOnly": "Doar grupul",
  "badge.external": "Extern",
  "badge.slowMoving": "Rotatie lenta",
  "badge.nonMoving": "Fara rotatie",
  "badge.missingDocs": "Documente lipsa",
  "filter.category": "Categorie",
  "filter.site": "Locatie",
  "filter.age": "Vechime",
  "filter.manufacturer": "Producator",
  "filter.price": "Pret",
  "filter.width": "Latime",
  "filter.country": "Tara",
  "filter.allCountries": "Toate tarile",
  "common.search": "Cauta materiale...",
  "common.loading": "Se incarca...",
  "common.noResults": "Niciun rezultat",
  "common.save": "Salveaza",
  "common.cancel": "Anuleaza",
  "common.submit": "Trimite",
  "common.delete": "Sterge",
  "common.edit": "Editeaza",
  "common.view": "Vizualizeaza",
  "common.close": "Inchide",
  "common.back": "Inapoi",
  "common.saving": "Se salveaza...",
  "common.create": "Creeaza",
  "home.newListings": "Listari noi",
  "home.highValue": "Stock de valoare mare",
  "home.featured": "Materiale recomandate",
  "auth.email": "E-mail",
  "auth.password": "Parola",
  "auth.name": "Nume complet",
  "auth.loginTitle": "Autentificare",
  "auth.registerTitle": "Creaza un cont",
  "auth.noAccount": "Nu aveti un cont?",
  "auth.hasAccount": "Aveti deja un cont?",
  "auth.registrationSuccess": "Inregistrare reusita!",
  "auth.pendingApproval": "Contul dvs. a fost creat si asteapta aprobarea administratorului.",
  "auth.registerDesc": "Creati un cont pentru a incepe sa comercializati materiale",
  "dashboard.totalInventory": "Inventar total",
  "dashboard.slowMoving": "Rotatie lenta (>180 zile)",
  "dashboard.nonMoving": "Fara rotatie (>360 zile)",
  "dashboard.pendingRequests": "Cereri in asteptare",
  "dashboard.monthlyTransfers": "Transferuri lunare",
  "dashboard.overdueItems": "Articole expirate",
  "dashboard.subtitle": "Prezentare generala a inventarului global",
  "dashboard.siteFilter": "Filtreaza dupa locatie",
  "dashboard.allSites": "Toate locatiile",
  "dashboard.slowMovingDesc": "Materiale de 181-360 zile",
  "dashboard.nonMovingDesc": "Materiale peste 360 zile",
  "dashboard.transfersDesc": "Transferuri interne luna aceasta",
  "dashboard.overdueDesc": "Articole care necesita atentie",
  "dashboard.ageChart": "Inventar dupa vechime",
  "dashboard.ageChartDesc": "Distributia valorii dupa vechime",
  "dashboard.siteRanking": "Clasamentul locatiilor",
  "dashboard.siteRankingDesc": "Locatii cu cel mai mult inventar cu rotatie lenta",
  "dashboard.overdueTitle": "Articole expirate (>360 zile)",
  "dashboard.overdueDesc2": "Aceste articole necesita atentie imediata",
  "dashboard.viewAllOverdue": "Vezi toate cele {{count}} articole expirate",
  "dashboard.viewNonMoving": "Vezi stocul fara rotatie",
  "dashboard.pendingRequestsLink": "Cereri in asteptare",
  "dashboard.importMaterials": "Importa materiale",
  "dashboard.age0_90": "0-90 zile",
  "dashboard.age91_180": "91-180 zile",
  "dashboard.age181_360": "181-360 zile",
  "dashboard.ageGt360": ">360 zile",
  "dashboard.slowMovingItems": "Articole cu rotatie lenta",
  "dashboard.totalMaterials": "Total materiale",
  "dashboard.totalMaterialsDesc": "Materiale active in inventar",
  "dashboard.externalSales": "Vanzari externe",
  "dashboard.externalSalesDesc": "Vanzari externe luna aceasta",
  "dashboard.sitePending": "Cereri in asteptare",
  "dashboard.sitePendingDesc": "Cereri in asteptare pentru aceasta locatie",
  "import.title": "Importa materiale",
  "import.subtitle": "Importa si exporta date materiale prin Excel",
  "import.downloadTemplate": "Descarca sablonul",
  "import.uploadFile": "Incarca fisier",
  "import.validate": "Valideaza",
  "import.execute": "Executa importul",
  "import.mode.overwrite": "Suprascrie tot",
  "import.mode.enrich": "Doar imbogatire",
  "import.mode.selective": "Selecteaza campuri",
  "import.export": "Export",
  "import.exportTitle": "Exporta materiale",
  "import.exportDesc": "Descarca date materiale ca fisier Excel cu filtre",
  "import.exportDownload": "Descarca Excel",
  "request.title": "Solicita material",
  "request.quantity": "Cantitate",
  "request.message": "Mesaj (optional)",
  "request.type.internal": "Transfer intern",
  "request.type.external": "Cerere externa",
  "requests.tab.my": "Cererile mele",
  "requests.tab.incoming": "Cereri primite",
  "requests.details": "Detalii cerere",
  "requests.detail.article": "Articol",
  "requests.detail.quantity": "Cantitate solicitata",
  "requests.detail.type": "Tip",
  "requests.detail.requestedBy": "Solicitat de",
  "requests.detail.date": "Data",
  "requests.detail.message": "Mesaj",
  "requests.from": "De la",
  "requests.viewDetails": "Vezi detalii",
  "requests.loginRequired": "Autentificare necesara",
  "requests.loginHint": "Autentificati-va pentru a vedea cererile dvs.",
  "requests.empty.my": "Nicio cerere trimisa",
  "requests.empty.myHint": "Nu ati facut inca cereri. Explorati materiale si trimiteti o cerere!",
  "requests.empty.incoming": "Nicio cerere primita",
  "requests.empty.incomingHint": "Nu aveti cereri primite pentru materialele dvs.",
  "requests.action.approve": "Aproba",
  "requests.action.reject": "Respinge",
  "requests.action.complete": "Finalizeaza",
  "requests.action.approveTitle": "Aproba cererea",
  "requests.action.rejectTitle": "Respinge cererea",
  "requests.action.completeTitle": "Finalizeaza cererea",
  "requests.action.approveDesc": "Aceasta va aproba cererea si va rezerva materialul.",
  "requests.action.rejectDesc": "Aceasta va respinge cererea.",
  "requests.action.completeDesc": "Aceasta va finaliza transferul si va actualiza inventarul.",
  "requests.action.approvedSuccess": "Cerere aprobata",
  "requests.action.rejectedSuccess": "Cerere respinsa",
  "requests.action.completedSuccess": "Cerere finalizata - inventar actualizat",
  "requests.action.failed": "Eroare la actualizarea cererii",
  "restricted.title": "Continut restrictionat",
  "restricted.loginHint": "Autentificati-va pentru a vedea preturi, cantitati si locatie.",
  "restricted.approvalHint": "Contul dvs. asteapta aprobare.",
  "restricted.cardHint": "Autentificati-va si obtineti aprobare pentru a vedea detalii",
  "admin.users": "Utilizatori",
  "admin.usersDesc": "Gestioneaza inregistrarile si aprobarile utilizatorilor",
  "admin.noUsers": "Niciun utilizator gasit",
  "admin.approved": "Aprobat",
  "admin.pending": "In asteptare",
  "admin.registeredAt": "Inregistrat",
  "admin.approveUser": "Aproba",
  "admin.revokeUser": "Revoca",
  "admin.userApproved": "Utilizator aprobat cu succes",
  "admin.userRevoked": "Acces utilizator revocat",
  "admin.userApproveFailed": "Eroare la actualizarea statusului",
  "admin.deleteUser": "Șterge utilizator",
  "admin.deleteUserTitle": "Șterge utilizator",
  "admin.deleteUserConfirm": "Sunteți sigur că doriți să ștergeți permanent utilizatorul {{name}} ({{email}})? Această acțiune nu poate fi anulată.",
  "admin.userDeleted": "Utilizator șters cu succes",
  "admin.userDeleteFailed": "Eroare la ștergerea utilizatorului",
  "admin.categoryTree": "Arbore categorii",
  "admin.categoryTreeDesc": "Gestioneaza categoriile de produse si ierarhia lor",
  "admin.addCategory": "Adauga categorie",
  "admin.editCategory": "Editeaza categorie",
  "admin.deleteCategory": "Sterge categorie",
  "admin.addCategoryDesc": "Creeaza o noua categorie de produs",
  "admin.editCategoryDesc": "Editeaza numele, categoria parinte sau ordinea",
  "admin.deleteCategoryConfirm": "Sunteti sigur ca doriti sa stergeti \"{{name}}\"?",
  "admin.categoryName": "Nume categorie",
  "admin.categoryNamePlaceholder": "ex. Folii si filme",
  "admin.parentCategory": "Categorie parinte",
  "admin.noParent": "Niciuna (nivel radacina)",
  "admin.sortOrder": "Ordine de sortare",
  "admin.categoryCreated": "Categorie creata",
  "admin.categoryUpdated": "Categorie actualizata",
  "admin.categoryDeleted": "Categorie dezactivata",
  "admin.categoryCreateFailed": "Eroare la crearea categoriei",
  "admin.categoryUpdateFailed": "Eroare la actualizarea categoriei",
  "admin.categoryDeleteFailed": "Eroare la stergerea categoriei",
  "admin.noCategoriesFound": "Nicio categorie gasita.",
  "admin.delete": "Sterge",
  "create.newTitle": "Publica material",
  "create.editTitle": "Editeaza material",
  "create.materialInfo": "Informatii material",
  "create.title": "Titlu",
  "create.titlePlaceholder": "ex. Film PE 500mm transparent",
  "create.description": "Descriere",
  "create.descPlaceholder": "Descriere detaliata a materialului...",
  "create.selectCategory": "Selecteaza categorie",
  "create.companyGroup": "Grup de companii",
  "create.selectGroup": "Selecteaza grup",
  "create.partNumber": "Numar piesa",
  "create.thickness": "Grosime",
  "create.grade": "Gradul materialului",
  "create.coreDiameter": "Diametru miez",
  "create.skuInfo": "Date stoc (SKU)",
  "create.addSku": "Adauga stoc",
  "create.addMore": "Adauga SKU",
  "create.selectSite": "Selecteaza locatie",
  "create.articleNumber": "Numar articol",
  "create.rolls": "Numar role",
  "create.bookValue": "Valoare contabila",
  "create.listPrice": "Pret de lista",
  "create.productionDate": "Data productie",
  "create.customerSpecific": "Specific clientului",
  "create.compliant": "Conform",
  "create.notesInternal": "Note interne",
  "create.notesInternalPlaceholder": "Vizibil doar intern...",
  "create.publish": "Publica",
  "create.materialCreated": "Material creat cu succes",
  "create.materialUpdated": "Material actualizat cu succes",
  "create.existingSkus": "Stoc existent",
  "create.noNewSkus": "Niciun stoc nou adaugat",
  "create.previewHint": "Previzualizare material",
  "create.untitled": "Material fara titlu",
  "create.titleRequired": "Titlul este obligatoriu",
  "create.categoryRequired": "Categoria este obligatorie",
  "create.manufacturerRequired": "Producatorul este obligatoriu",
  "create.partNumberRequired": "Numarul piesei este obligatoriu",
  "create.groupRequired": "Grupul de companii este obligatoriu",
  "create.siteRequired": "Locatia este obligatorie",
  "create.articleRequired": "Numarul articolului este obligatoriu",
  "create.quantityRequired": "Cantitatea este obligatorie",
  "create.saveError": "Eroare la salvarea materialului",
  "watchlist.loginRequired": "Autentificare necesara",
  "watchlist.loginHint": "Autentificati-va pentru a vedea lista de urmarire",
  "watchlist.empty": "Lista dvs. de urmarire este goala",
  "watchlist.emptyHint": "Explorati materiale si faceti clic pe pictograma inima",
  "watchlist.browse": "Explorati materiale",
  "watchlist.remove": "Sterge",
  "watchlist.priceOnRequest": "Pret la cerere",
  "watchlist.addedOn": "Adaugat pe",
  "watchlist.itemCount": "{{count}} articole in lista dvs.",
  "sustainability.title": "Impact asupra sustenabilitatii",
  "sustainability.subtitle": "Reducerea deseurilor prin redistribuire inteligenta",
  "sustainability.heroTagline": "Economie circulara pentru ambalaje",
  "sustainability.heroDesc": "Fiecare material redistribuit este unul mai putin produs de la zero. Impreuna reducem CO2, economisim resurse si construim un ecosistem de fabricatie circular.",
  "sustainability.co2Saved": "CO2 economisit",
  "sustainability.co2SavedDesc": "Emisii evitate estimate",
  "sustainability.materialsRedistributed": "Materiale redistribuite",
  "sustainability.materialsRedistributedDesc": "Transferate cu succes intre locatii",
  "sustainability.valueSaved": "Valoare conservata",
  "sustainability.valueSavedDesc": "Capital de lucru economisit",
  "sustainability.activeSites": "Locatii active",
  "sustainability.activeSitesDesc": "Locatii care participa la redistribuire",
  "sustainability.circularRate": "Rata economiei circulare",
  "sustainability.circularRateDesc": "Materiale cu o a doua viata",
  "sustainability.atRisk": "Materiale in risc",
  "sustainability.atRiskDesc": "Stoc cu rotatie lenta/nula redistribuibil",
  "sustainability.pendingRedist": "Redistribuiri in curs",
  "sustainability.pendingRedistDesc": "Transferuri in curs de procesare",
  "sustainability.availableForReuse": "Disponibil pentru reutilizare",
  "sustainability.impactBanner": "Impreuna prevenim deseurile de ambalare si economisim resurse",
  "sustainability.kgUnit": "kg",
  "sustainability.tonUnit": "t",
  "sustainability.downloadReport": "Descarca raport ESG",
  "sustainability.downloadReportDesc": "Genereaza un raport PDF de sustenabilitate",
  "sustainability.reportGenerating": "Se genereaza raportul...",
  "sustainability.reportReady": "Raport ESG descarcat cu succes",
  "sustainability.reportError": "Eroare la generarea raportului",
  "matching.title": "Material Matching",
  "matching.subtitle": "Potrivirea automata a excedentelor cu cererea altor locatii",
  "matching.refresh": "Actualizeaza",
  "matching.matches": "Potriviri",
  "matching.matchRate": "Rata de potrivire",
  "matching.potSavings": "Econ. pot.",
  "matching.sites": "Locatii",
  "matching.surplusAvailable": "{{count}} excedente disponibile",
  "matching.demandPositions": "{{count}} pozitii de cerere",
  "matching.matchedQuantity": "{{count}} kg cantitate potrivita",
  "matching.providers": "{{count}} furnizori",
  "matching.consumers": "{{count}} solicitanti",
  "matching.topMaterials": "Materialele cele mai potrivite",
  "matching.offerSite": "Locatie furnizor",
  "matching.demandSite": "Locatie solicitant",
  "matching.manufacturer": "Producator",
  "matching.searchManufacturer": "Cauta producator...",
  "matching.allSites": "Toate locatiile",
  "matching.noMatches": "Nicio potrivire",
  "matching.noMatchesDesc": "Nu s-au gasit potriviri intre excedente si listele de cerere.",
  "matching.matchesFound": "{{count}} potrivire/potriviri gasite",
  "matching.material": "Material",
  "matching.provider": "Furnizor",
  "matching.consumer": "Solicitant",
  "matching.quantity": "Cantitate",
  "matching.bookValue": "Valoare contabila",
  "matching.age": "Vechime",
  "matching.width": "Latime",
  "matching.widthFit": "Conform",
  "matching.widthDeviation": "Abat.",
  "matching.action": "Actiune",
  "matching.view": "Vezi",
  "matching.age0_90": "0–90 zile",
  "matching.age91_180": "91–180 zile",
  "matching.age181_360": "181–360 zile",
  "matching.ageGt360": "> 360 zile",
  "analytics.title": "Analize si rapoarte",
  "analytics.subtitle": "Analiza tendintelor, performanta locatiilor si evaluari ale potrivirilor",
  "analytics.tabTrends": "Tendinte",
  "analytics.tabSites": "Locatii",
  "analytics.tabMatching": "Matching",
  "analytics.last6Months": "Ultimele 6 luni",
  "analytics.last12Months": "Ultimele 12 luni",
  "analytics.last24Months": "Ultimele 24 luni",
  "analytics.inventoryTrend": "Evolutia inventarului",
  "analytics.inventoryTrendDesc": "Dezvoltarea lunara a numarului de articole si a valorii inventarului",
  "analytics.articles": "Articole",
  "analytics.valueKEUR": "Valoare (kEUR)",
  "analytics.transactionVolume": "Volumul tranzactiilor",
  "analytics.transactionVolumeDesc": "Tranzactii lunare",
  "analytics.transactions": "Tranzactii",
  "analytics.requestTrend": "Evolutia cererilor",
  "analytics.requestTrendDesc": "Total vs. cereri finalizate",
  "analytics.requests": "Cereri",
  "analytics.completed": "Finalizate",
  "analytics.siteComparison": "Comparatie locatii: valoarea inventarului",
  "analytics.siteComparisonDesc": "Valoare totala (kEUR) pe locatie",
  "analytics.redistributionRanking": "Clasament redistribuire",
  "analytics.redistributionRankingDesc": "Redistribuiri finalizate pe locatie",
  "analytics.redistributions": "Redistribuiri",
  "analytics.openRequests": "Cereri deschise",
  "analytics.siteDetails": "Detalii locatie",
  "analytics.site": "Locatie",
  "analytics.value": "Valoare (kEUR)",
  "analytics.slowMoving": "Rotatie lenta",
  "analytics.redistributed": "Redistribuit",
  "analytics.demand": "Cerere",
  "analytics.noSiteData": "Nu sunt disponibile date pentru locatii",
  "analytics.kpiMatches": "Potriviri",
  "analytics.kpiMatchRate": "Rata de potrivire",
  "analytics.kpiMatchedValue": "Valoare potrivita",
  "analytics.kpiMaterials": "Materiale",
  "analytics.topMatchedMaterials": "Materialele cele mai potrivite",
  "analytics.categoryDistribution": "Potriviri pe categorie",
  "analytics.sitePairFlows": "Fluxuri de locatii (Furnizor → Solicitant)",
  "analytics.sitePairFlowsDesc": "Cele mai frecvente fluxuri de materiale intre locatii",
  "analytics.noData": "Fara date",
  "analytics.noMatchingData": "Nu sunt disponibile date de potrivire",
  "transactions.title": "Tranzactii",
  "transactions.subtitle": "Toate tranzactiile finalizate si deschise",
  "transactions.allStatuses": "Toate statusurile",
  "transactions.statusCompleted": "Finalizata",
  "transactions.statusCancelled": "Anulata",
  "transactions.statusPending": "Deschisa",
  "transactions.total": "Tranzactii",
  "transactions.completed": "Finalizate",
  "transactions.totalValue": "Valoare totala",
  "transactions.date": "Data",
  "transactions.material": "Material",
  "transactions.type": "Tip",
  "transactions.seller": "Vanzator",
  "transactions.buyer": "Cumparator",
  "transactions.quantity": "Cantitate",
  "transactions.value": "Valoare",
  "transactions.fee": "Comision",
  "transactions.status": "Status",
  "transactions.rating": "Evaluare",
  "transactions.internal": "Intern",
  "transactions.external": "Extern",
  "transactions.empty": "Inca nu exista tranzactii",
  "transactions.emptyDesc": "Tranzactiile sunt create automat la finalizarea cererilor.",
  "transactions.rate": "Evalueaza",
  "transactions.rated": "Evaluat",
  "transactions.rateTitle": "Evalueaza tranzactia",
  "transactions.counterparty": "Contrapartida",
  "transactions.unknown": "Necunoscut",
  "transactions.commentLabel": "Comentariu (optional)",
  "transactions.commentPlaceholder": "Cum a fost cooperarea?",
  "transactions.submitRating": "Trimite evaluarea",
  "transactions.submitting": "Se trimite...",
  "transactions.ratingSuccess": "Evaluare trimisa",
  "transactions.ratingError": "Eroare la trimiterea evaluarii",
  "transactions.ratingRequired": "Evaluati cel putin o categorie",
  "transactions.loadError": "Eroare la incarcarea tranzactiilor",
  "transactions.reviews": "Evaluari",
  "transactions.noReviews": "Inca nu exista evaluari.",
  "transactions.comments": "Comentarii",
  "transactions.group": "Grup",
  "transactions.review": "evaluari",
  "notifications.title": "Notificari",
  "notifications.allRead": "Toate citite",
  "notifications.none": "Nicio notificare",
  "notifications.noFiltered": "Nicio notificare potrivita",
  "notifications.filterAll": "Toate",
  "notifications.filterMatches": "Potriviri",
  "notifications.filterOther": "Altele",
  "notifications.newMatch": "{{count}} potrivire noua de material",
  "notifications.newMatches": "{{count}} potriviri noi de material",
  "notifications.goToDashboard": "Mergi la panou",
  "notifications.matchDashboard": "Afiseaza panoul Material Matching",
  "notifications.justNow": "chiar acum",
  "notifications.minutesAgo": "acum {{count}} min",
  "notifications.hoursAgo": "acum {{count}} ore",
  "notifications.daysAgo": "acum {{count}} z",
  "notifications.site": "Locatie",
  "notifications.typeMatch": "Potrivire",
  "notifications.typeApproval": "Potrivire aprobare",
  "notifications.typeRequest": "Cerere",
  "notifications.typeEscalation": "Escaladare",
  "notifications.typeLogistics": "Logistica",
  "notifications.typeInfo": "Info",
  "partners.heroTitle": "Cumpără. Vinde. Reutilizează. Materiale excedentare — mai inteligent.",
  "partners.heroSubtitle": "Alătură-te pieței lider pentru excedente de ambalaje. Acces la materiale verificate de la producători de top.",
  "partners.ctaRegister": "Înregistrează-te ca partener",
  "partners.ctaBrowse": "Explorează materiale",
  "partners.trust1": "Înregistrare gratuită",
  "partners.trust2": "Furnizori verificați",
  "partners.trust3": "Fără angajament",
  "partners.howItWorksLabel": "Proces",
  "partners.howItWorksTitle": "Cum funcționează",
  "partners.howItWorksSubtitle": "Trei pași simpli pentru a începe să economisești.",
  "partners.step1Title": "Înregistrare",
  "partners.step1Desc": "Creează-ți contul de companie în câteva minute.",
  "partners.step2Title": "Explorare",
  "partners.step2Desc": "Caută mii de materiale excedentare verificate.",
  "partners.step3Title": "Solicitare",
  "partners.step3Desc": "Trimite o solicitare direct furnizorului.",
  "partners.benefitsTitle": "De ce să alegi Surplify",
  "partners.benefit1Title": "Economisește până la 40%",
  "partners.benefit1Desc": "Acces la materiale excedentare la o fracțiune din costul original.",
  "partners.benefit2Title": "Calitate verificată",
  "partners.benefit2Desc": "Fiecare anunț include date de la producător și rapoarte de stare.",
  "partners.benefit3Title": "Impact ESG",
  "partners.benefit3Desc": "Fiecare achiziție reduce emisiile de CO2.",
  "partners.trustTitle": "De încredere pentru liderii din industrie",
  "partners.trustSubtitle": "Companii din toată Europa se bazează pe Surplify",
  "partners.trustUsers": "50+ companii",
  "partners.trustStat1": "40%",
  "partners.trustStat1Label": "Economii medii la costuri",
  "partners.trustStat2": "500+",
  "partners.trustStat2Label": "Anunțuri verificate",
  "partners.trustStat3": "50+",
  "partners.trustStat3Label": "Companii partenere active",
  "partners.ctaFinalTitle": "Gata să economisești?",
  "partners.ctaFinalDesc": "Alătură-te sutelor de companii care folosesc deja Surplify.",
  "partners.ctaFinalRegister": "Începe gratuit",
  "partners.noCredit": "Fără card de credit. Înregistrare gratuită.",
  "onboarding.step": "Pasul",
  "onboarding.of": "din",
  "onboarding.skip": "Sari deocamdată",
  "onboarding.next": "Înainte",
  "onboarding.finish": "Începe",
  "onboarding.restartTour": "Reia turul",
  "onboarding.step1Title": "Bun venit la Surplify",
  "onboarding.step1Desc": "Surplify este piața lider pentru excedente de ambalaje.",
  "onboarding.step1Points": ["Mii de materiale verificate", "Economisești până la 40%", "Urmărire ESG automată"],
  "onboarding.step2Title": "Profilul companiei tale",
  "onboarding.step2Desc": "Profilul tău reprezintă compania ta pe platformă.",
  "onboarding.step2Points": ["Adaugă logo și descriere", "Verifică datele de contact", "Setează preferințele"],
  "onboarding.step3Title": "Găsire materiale",
  "onboarding.step3Desc": "Folosește căutarea avansată pentru a găsi exact ce ai nevoie.",
  "onboarding.step3Points": ["Caută după producător sau număr articol", "Filtrează după categorie și țară", "Salvează în lista de urmărire"],
  "onboarding.step4Title": "Solicitare materiale",
  "onboarding.step4Desc": "Trimite o solicitare direct furnizorului.",
  "onboarding.step4Points": ["Indică cantitatea necesară", "Adaugă un mesaj", "Urmărește statusul în timp real"],
  "admin.addCompany": "Adauga companie",
  "admin.addGroup": "Adauga grup",
  "admin.addSite": "Adauga locatie",
  "admin.approvalRequired": "Aprobare necesara",
  "admin.approvalRequiredDesc": "Necesita aprobarea managerului pentru solicitari",
  "admin.approve": "Aproba",
  "admin.approveCompany": "Aproba",
  "admin.auditAction": "Actiune",
  "admin.auditAll": "Toate",
  "admin.auditChanges": "Modificari",
  "admin.auditEntity": "Entitate",
  "admin.auditFilterAction": "Filtreaza dupa actiune",
  "admin.auditFilterEntity": "Filtreaza dupa entitate",
  "admin.auditLog": "Jurnal de audit",
  "admin.auditLogDesc": "Istoricul complet al tuturor modificarilor sistemului",
  "admin.auditNextPage": "Urmatorul",
  "admin.auditNoEntries": "Nu s-au gasit inregistrari de audit.",
  "admin.auditPage": "Pagina {{page}} din {{pages}}",
  "admin.auditPrevPage": "Anterior",
  "admin.auditTimestamp": "Data si ora",
  "admin.auditUser": "Utilizator",
  "admin.autoApproval": "Aprobare automata",
  "admin.categories": "Categorii",
  "admin.city": "Oras",
  "admin.companyApproved": "Companie aprobata",
  "admin.companyCreated": "Companie creata cu succes",
  "admin.companyFailed": "Eroare la actualizarea companiei",
  "admin.companyName": "Numele companiei",
  "admin.companyNamePlaceholder": "ex. PackPro GmbH",
  "admin.companyRejected": "Companie respinsa",
  "admin.contactEmail": "E-mail de contact",
  "admin.contactName": "Nume de contact",
  "admin.contactPhone": "Telefon de contact",
  "admin.country": "Tara",
  "admin.defaultImage": "Imagine implicita",
  "admin.docsBlocked": "Docs blocate",
  "admin.domainsAllowed": "Domenii permise",
  "admin.emailsFailed": "E-mailuri esuate",
  "admin.emailsSent": "E-mailuri trimise",
  "admin.emailsSkipped": "Ignorate",
  "admin.escalatedRequests": "Solicitari escaladate",
  "admin.escalationDays": "Zile de escaladare",
  "admin.escalationDaysDesc": "Zile inainte de notificarile de escaladare",
  "admin.externalBlocked": "Extern blocat",
  "admin.externalCompanies": "Companii externe",
  "admin.externalCompaniesDesc": "Gestioneaza inregistrarile si aprobarile companiilor externe",
  "admin.externalEnabled": "Publicare externa activata",
  "admin.externalEnabledDesc": "Permite materialelor sa fie vizibile extern",
  "admin.externalOpen": "Extern deschis",
  "admin.groupAdmin": "Admin de grup",
  "admin.groupAdminDesc": "Gestioneaza strategia si utilizatorii grupului tau",
  "admin.groupName": "Numele grupului",
  "admin.groupNamePlaceholder": "ex. Acme Packaging Group",
  "admin.groupUsersDesc": "Gestioneaza si aproba utilizatorii din grupul tau",
  "admin.guide": "Ghid",
  "admin.guideAudit": "Jurnal de audit",
  "admin.guideAuditText": "Jurnalul de audit ofera un istoric complet al tuturor modificarilor sistemului pentru conformitate si trasabilitate.",
  "admin.guideAuditTip": "Jurnalul de audit este imuabil si nu poate fi editat sau sters.",
  "admin.guideCategories": "Gestionarea categoriilor",
  "admin.guideCategoriesText": "Categoriile organizeaza materialele intr-o structura ierarhica de tip arbore.",
  "admin.guideCategoriesTip": "Categoriile sterse sunt dezactivate (stergere soft). Materialele atribuite anterior raman accesibile.",
  "admin.guideDashboard": "Dashboard si Rapoarte",
  "admin.guideDashboardText": "Dashboard-ul ofera KPI-uri in timp real despre varsta inventarului, activitatea transferurilor, metricile de sustenabilitate si valoarea la risc.",
  "admin.guideDashboardTip": "Raportul de sustenabilitate include estimari de economisire CO2 bazate pe cantitatile de materiale redistribuite.",
  "admin.guideDesc": "Ghid complet pentru configurarea platformei, guvernanta si gestionarea zilnica",
  "admin.guideExternal": "Companii externe",
  "admin.guideExternalText": "Companiile externe se pot autoregistra pe platforma. Administratorii revizuiesc si aproba sau resping solicitarile.",
  "admin.guideExternalTip": "La aprobare sau respingere, se trimite automat o notificare prin e-mail contactului companiei.",
  "admin.guideGettingStarted": "Primii pasi",
  "admin.guideGettingStartedText": "Bine ai venit la Surplify! Aceasta platforma ajuta organizatia ta sa reduca capitalul de lucru redistribuind materiile prime cu rotatie lenta intre locatii.",
  "admin.guideGettingStartedTip": "Foloseste butonul 'Incarca date exemplu' pentru a popula categorii si materiale demo.",
  "admin.guideImport": "Import/Export Excel",
  "admin.guideImportText": "Pagina de import suporta gestionarea in masa a materialelor prin incarcarea fisierelor Excel.",
  "admin.guideImportTip": "Foloseste modul 'Doar imbogatire' pentru actualizari incrementale fara a suprascrie datele existente.",
  "admin.guideNotifications": "Notificari prin e-mail",
  "admin.guideNotificationsText": "Platforma trimite notificari automate prin e-mail pentru solicitari escaladate, solicitari noi de materiale si schimbari de status ale companiilor externe.",
  "admin.guideNotificationsTip": "E-mailurile de escaladare sunt declansate cand solicitarile in asteptare depasesc pragul 'Zile de escaladare' configurat.",
  "admin.guideScenarios": "Configurarea scenariilor",
  "admin.guideScenariosText": "Scenariile controleaza regulile de guvernanta pentru redistribuirea materialelor.",
  "admin.guideScenariosTip": "Dashboard-ul de impact al scenariului arata efectele in timp real ale setarilor actuale.",
  "admin.guideTitle": "Ghid de administrare",
  "admin.guideVotes.title": "Sectiunile din ghid cu cele mai slabe evaluari",
  "admin.guideVotes.desc": "Cele 5 sectiuni cu cel mai negativ feedback al utilizatorilor - merita revizuite.",
  "admin.guideVotes.empty": "Inca nu exista evaluari.",
  "admin.guideVotes.loading": "Se incarca evaluarile…",
  "admin.guideVotes.unknownSection": "Sectiune necunoscuta",
  "admin.guideVotes.score": "Scor net (degete sus − jos)",
  "admin.guideUsers": "Gestionarea utilizatorilor",
  "admin.guideUsersText": "Utilizatorii se inregistreaza prin platforma si trebuie aprobati inainte de a accesa datele sensibile.",
  "admin.guideUsersTip": "Revocarea unui utilizator nu sterge contul sau. Poate fi re-aprobat oricand.",
  "admin.houseNumber": "Numar",
  "admin.industry": "Industrie",
  "admin.internalWindow": "Fereastra interna (zile)",
  "admin.internalWindowDesc": "Zile in care articolele sunt vizibile doar intern",
  "admin.internalWindowItems": "In fereastra interna",
  "admin.lastCheck": "Ultima verificare",
  "admin.legalPageContent": "Continutul paginii (HTML)",
  "admin.legalPageTitle": "Titlul paginii",
  "admin.legalPages": "Pagini legale",
  "admin.legalPagesDesc": "Editeaza paginile de suport, termeni, nota legala, confidentialitate",
  "admin.legalPreview": "Previzualizare",
  "admin.loadSettings": "Incarca setari",
  "admin.manualApproval": "Aprobare manuala",
  "admin.masterData": "Date de referinta",
  "admin.materialApprovals": "Aprobari de materiale",
  "admin.materialApprovalsDesc": "Revizuieste si aproba listarile de materiale externe",
  "admin.mode.aggressive_cash": "Agresiv (Cash)",
  "admin.mode.aggressive_cashDesc": "Ferestre mai scurte, lichidare mai rapida",
  "admin.mode.balanced": "Echilibrat",
  "admin.mode.balancedDesc": "Reguli de guvernanta standard",
  "admin.mode.conservative": "Conservator",
  "admin.mode.conservativeDesc": "Ferestre mai lungi, mai multe aprobari",
  "admin.mode.crisis_mode": "Mod de criza",
  "admin.mode.crisis_modeDesc": "Mod de eliminare de urgenta",
  "admin.ndaNotSigned": "NDA in asteptare",
  "admin.ndaSigned": "NDA semnat",
  "admin.noCompanies": "Nicio companie externa inregistrata.",
  "admin.noGroups": "Niciun grup gasit. Adauga primul tau grup.",
  "admin.noNotifications": "Nicio notificare trimisa",
  "admin.noPendingMaterials": "Nicio aprobare de material in asteptare",
  "admin.noSites": "Nicio locatie gasita. Adauga prima ta locatie.",
  "admin.noSitesNoGroup": "Creeaza mai intai un grup inainte de a adauga locatii.",
  "admin.notifDaysPending": "Zile in asteptare",
  "admin.notifExtApproved": "Aprobat",
  "admin.notifExtCompany": "Companie externa",
  "admin.notifExtRejected": "Respins",
  "admin.notifMaterial": "Material",
  "admin.notifOwner": "Proprietar",
  "admin.notifRecipients": "Destinatari",
  "admin.notifRequestedQty": "Cantitate solicitata",
  "admin.notifRequester": "Solicitant",
  "admin.notifSentAt": "Trimis la",
  "admin.notifSite": "Locatie",
  "admin.notifStatus": "Status",
  "admin.notifTypeEscalation": "Escaladare",
  "admin.notifTypeExtCompany": "Comp. externe",
  "admin.notifTypeNewRequest": "Solicitare noua",
  "admin.notifications": "Notificari",
  "admin.notificationsDesc": "Istoricul e-mailurilor de escaladare si gestionare",
  "admin.notificationsTitle": "Notificari prin e-mail",
  "admin.orgDesc": "Gestioneaza organizatiile tenant",
  "admin.orgTitle": "Grupuri de companii",
  "admin.organizations": "Organizatii",
  "admin.platformAdminDesc": "Administrarea platformei - gestioneaza toate grupurile, locatiile si utilizatorii",
  "admin.postalCode": "Cod postal",
  "admin.reject": "Respinge",
  "admin.rejectCompany": "Respinge",
  "admin.saveSettings": "Salveaza setarile",
  "admin.scenarioImpact": "Impactul scenariului",
  "admin.scenarioImpactDesc": "Impact in timp real al setarilor actuale",
  "admin.scenarioMode": "Mod scenariu",
  "admin.scenarios": "Scenarii",
  "admin.scenariosDesc": "Configureaza reguli de guvernanta si fluxuri de aprobare",
  "admin.scenariosTitle": "Configurarea scenariilor",
  "admin.seedData": "Incarca date exemplu",
  "admin.selectGroup": "Selecteaza grupul",
  "admin.selectGroupPlaceholder": "Alege un grup...",
  "admin.settingsFailed": "Eroare la salvarea setarilor",
  "admin.settingsSaved": "Setari salvate cu succes",
  "admin.sites": "Locatii",
  "admin.sitesDesc": "Gestioneaza locatiile de depozitare",
  "admin.sitesTitle": "Locatii",
  "admin.street": "Strada",
  "admin.strictDocs": "Documentatie stricta",
  "admin.strictDocsActive": "Documentatie stricta activa",
  "admin.strictDocsDesc": "Blocheaza importurile fara fise tehnice",
  "admin.submittedBy": "Trimis de",
  "admin.title": "Administrare",
  "admin.totalNotifications": "Total notificari",
  "admin.triggerCheck": "Verifica acum",
  "admin.triggerCheckDesc": "Verifica manual solicitarile escaladate si trimite notificari",
  "admin.triggerCheckFailed": "Verificarea escaladarii a esuat",
  "admin.triggerCheckSuccess": "Verificarea escaladarii finalizata",
  "admin.uploadDefaultImage": "Incarca imagine",
  "admin.vatId": "CUI/CIF",
  "admin.website": "Site web",
  "auth.companyGroup": "Grup de companii",
  "auth.selectCompanyGroup": "Selecteaza grupul tau...",
  "auth.selectSite": "Selecteaza fabrica...",
  "auth.site": "Fabrica / Locatie",
  "bulk.browse": "Rasfoieste fisiere",
  "bulk.col.article_number": "Nr. articol",
  "bulk.col.manufacturer_name": "Producator",
  "bulk.col.manufacturer_part_number": "Numar de piesa",
  "bulk.col.notes_internal": "Note",
  "bulk.col.number_of_rolls": "Role",
  "bulk.col.quantity": "Cantitate",
  "bulk.col.uom": "UdM",
  "bulk.created": "Create",
  "bulk.downloadTemplate": "Descarca model",
  "bulk.dropHint": "Trage si plaseaza fisierul Excel/CSV aici",
  "bulk.duplicates": "Existent (Actualizare)",
  "bulk.enriched": "Imbogatite",
  "bulk.errors": "Erori",
  "bulk.executeImport": "Importa {{count}} randuri",
  "bulk.importComplete": "Import finalizat!",
  "bulk.importError": "Importul a esuat",
  "bulk.importMode": "Mod de import pentru duplicate",
  "bulk.importMore": "Importa mai mult",
  "bulk.importing": "Se importa...",
  "bulk.invalidFile": "Format fisier invalid. Foloseste .xlsx, .xls sau .csv",
  "bulk.modeEnrich": "Imbogatire",
  "bulk.modeEnrichDesc": "Completeaza doar campurile goale, pastreaza existentele",
  "bulk.modeOverwrite": "Suprascrie",
  "bulk.modeOverwriteDesc": "Inlocuieste toate campurile cu valorile importate",
  "bulk.moreRows": "randuri suplimentare",
  "bulk.newItems": "Articole noi",
  "bulk.parseError": "Eroare la analiza fisierului",
  "bulk.rejected": "Respinse",
  "bulk.rowError": "Rand {{row}}",
  "bulk.rows": "Randuri",
  "bulk.rowsLoaded": "{{count}} randuri incarcate",
  "bulk.subtitle": "Importa mai multe materiale odata prin Excel/CSV",
  "bulk.templateDownloaded": "Model descarcat",
  "bulk.templateError": "Eroare la descarcarea modelului",
  "bulk.title": "Incarcare in masa",
  "bulk.updated": "Actualizate",
  "bulk.valid": "Valid",
  "bulk.validate": "Valideaza datele",
  "bulk.validateError": "Validarea a esuat",
  "bulk.validating": "Se valideaza...",
  "bulk.validationErrors": "Erori de validare",
  "common.deleting": "Se sterge...",
  "create.addDocument": "Adauga document PDF",
  "create.techSpec": "Fișă tehnică",
  "create.techSpecHint": "Este necesară cel puțin o fișă tehnică (PDF). Cumpărătorii au nevoie de specificație pentru a evalua materialul.",
  "create.techSpecRequired": "Obligatoriu",
  "create.addTechSpec": "Încarcă fișa tehnică (PDF)",
  "create.techSpecRequiredError": "Te rugăm să încarci o fișă tehnică (PDF) înainte de salvare.",
  "create.addPhoto": "Fotografie",
  "create.documents": "Documente (PDF)",
  "create.erpArticleNumber": "Numar articol ERP",
  "create.materialIndex": "Index material",
  "create.photos": "Fotografii",
  "dashboard.agingAutoCalculated": "Imbatranirea se calculeaza automat de la data productiei",
  "dashboard.categoryBreakdown": "Defalcare pe categorii",
  "dashboard.categoryBreakdownDesc": "Principalele categorii dupa valoarea la risc",
  "dashboard.items": "Articole",
  "dashboard.kEUR": "kEUR",
  "dashboard.skus": "SKU-uri",
  "dashboard.topRisk": "Materiale cu risc ridicat",
  "dashboard.topRiskDesc": "Materiale cu cea mai mare valoare (rotatie lenta/nula)",
  "dashboard.totalValue": "Valoarea totala a inventarului",
  "dashboard.totalValueDesc": "Valoare contabila totala a tuturor SKU-urilor active",
  "dashboard.valueAtRisk": "Valoare la risc",
  "dashboard.valueAtRiskDesc": "Valoare contabila a stocului cu rotatie lenta/nula",
  "ext.alreadyRegistered": "Deja inregistrat?",
  "ext.backStep": "Inapoi",
  "ext.chooseRegistrationType": "Cum doresti sa te inregistrezi?",
  "ext.companyInfo": "Date companie",
  "ext.confirmPassword": "Confirma parola",
  "ext.continue": "Continua",
  "ext.createFirstListing": "Publica primul material",
  "ext.createListing": "Publica material",
  "ext.deleteConfirmDesc": "Esti sigur ca doresti sa stergi acest material? Aceasta actiune nu poate fi anulata.",
  "ext.deleteConfirmTitle": "Sterge materialul?",
  "ext.fillRequired": "Completeaza toate campurile obligatorii",
  "ext.groupName": "Numele grupului",
  "ext.internalUser": "Utilizator intern?",
  "ext.linkedUsers": "Utilizatori legati",
  "ext.materialDeleted": "Material sters",
  "ext.myCompany": "Compania mea",
  "ext.myListings": "Anunturile mele",
  "ext.nextStep": "Urmatorul: Cont de utilizator",
  "ext.noCompanyLinked": "Nicio companie externa legata de contul tau",
  "ext.noLinkedUsers": "Niciun utilizator legat",
  "ext.noListings": "Niciun material publicat",
  "ext.noListingsDesc": "Publica primul tau material pentru a-l oferi pe piata.",
  "ext.passwordMismatch": "Parolele nu corespund",
  "ext.passwordTooShort": "Parola trebuie sa aiba cel putin 6 caractere",
  "ext.pendingMessage": "Inregistrarea ta este in curs de verificare. Odata aprobata, vei putea oferi materiale pe piata.",
  "ext.pendingTitle": "Aprobare in asteptare",
  "ext.portalTitle": "Portal companie",
  "ext.registerAsExternal": "Inregistreaza-te ca companie externa",
  "ext.registerAsGroup": "Ca grup",
  "ext.registerAsGroupDesc": "Companie cu mai multe fabrici/locatii",
  "ext.registerAsSite": "Ca locatie individuala",
  "ext.registerAsSiteDesc": "Locatie unica fara grup parinte",
  "ext.registerDesc": "Inregistreaza compania ta pentru a oferi materiale pe piata.",
  "ext.registerGroupDesc": "Inregistreaza grupul tau pentru a participa pe piata cu mai multe locatii.",
  "ext.registerInternal": "Inregistreaza-te aici",
  "ext.registerSiteDesc": "Inregistreaza locatia ta ca locatie unica pe piata.",
  "ext.registerTitle": "Inregistreaza-te ca companie externa",
  "ext.registrationPending": "Compania ta este in curs de verificare. Vei fi notificat cand accesul tau va fi activat.",
  "ext.registrationSuccess": "Inregistrare reusita!",
  "ext.registrationType": "Tip",
  "ext.rejectedMessage": "Din pacate, inregistrarea ta a fost respinsa. Contacteaza suportul pentru mai multe informatii.",
  "ext.rejectedTitle": "Inregistrare respinsa",
  "ext.siteName": "Numele locatiei",
  "ext.submitRegistration": "Trimite inregistrarea",
  "ext.userAccount": "Cont de utilizator",
  "filter.advancedFilters": "Filtre avansate",
  "filter.ageBucket": "Varsta stocului",
  "filter.age_0_90": "< 3 luni",
  "filter.age_181_360": "6-12 luni",
  "filter.age_91_180": "3-6 luni",
  "filter.age_gt_360": "> 12 luni",
  "filter.basicFilters": "Filtre",
  "filter.both": "Ambele",
  "filter.certifications": "Certificari",
  "filter.clearAll": "Sterge tot",
  "filter.clearAllFilters": "Sterge toate filtrele",
  "filter.clearFilters": "Sterge filtrele",
  "filter.complianceFlag": "Indicator conformitate",
  "filter.compliant": "Conform",
  "filter.core": "Miez",
  "filter.coreDiameter": "Diametrul miezului",
  "filter.customerSpecific": "Specific clientului",
  "filter.filters": "Filtre",
  "filter.materialProperties": "Proprietati material",
  "filter.max": "Max",
  "filter.min": "Min",
  "filter.minQuantity": "Cantitate minima",
  "filter.no": "Nu",
  "filter.qty": "Cant.",
  "filter.quantity": "Cantitate",
  "filter.stockDetails": "Detalii stoc",
  "filter.technicalSpecs": "Specificatii tehnice",
  "filter.thickness": "Grosime",
  "filter.thicknessRange": "Interval grosime",
  "filter.widthRange": "Interval latime",
  "filter.yes": "Da",
  "footer.agb": "Termeni si conditii",
  "footer.datenschutz": "Politica de confidentialitate",
  "footer.datenschutzeinstellungen": "Setari de confidentialitate",
  "footer.forPartners": "Pentru parteneri",
  "footer.impressum": "Nota legala",
  "footer.legalTitle": "Legal",
  "footer.marketplace": "Piata",
  "footer.rights": "Toate drepturile rezervate.",
  "footer.support": "Suport",
  "footer.tagline": "Piata guvernata pentru materiale de ambalare excedentare.",
  "group.allSites": "Toate locatiile",
  "group.filterSite": "Filtreaza dupa locatie",
  "group.filterStatus": "Filtreaza dupa status",
  "group.noMaterials": "Niciun material gasit in grupul tau",
  "group.otherSite": "Alta locatie",
  "group.ownMaterial": "Material propriu",
  "group.sites": "Locatii",
  "group.skuCount": "{{count}} SKU-uri",
  "group.subtitle": "Toate materialele de pe toate locatiile din grupul tau",
  "group.title": "Materialele grupului meu",
  "group.totalValue": "Valoare totala",
  "groupRequests.empty": "Nicio solicitare primita",
  "groupRequests.emptyHint": "Nu exista solicitari adresate locatiilor tale.",
  "groupRequests.filterAll": "Toate statusurile",
  "groupRequests.pending": "in asteptare",
  "groupRequests.site": "Locatie tinta",
  "groupRequests.subtitle": "Solicitari adresate locatiilor grupului tau",
  "groupRequests.title": "Solicitari primite de la locatie",
  "masterData.applied": "Date de referinta aplicate",
  "masterData.appliedLabel": "Date de referinta aplicate",
  "masterData.matchesFound": "Date de referinta gasite",
  "masterData.searchPlaceholder": "Cauta dupa furnizor, nr. articol...",
  "myMaterials.allStatuses": "Toate statusurile",
  "myMaterials.archive": "Arhiveaza",
  "myMaterials.archiveDesc": "Materialul va fi arhivat si nu va mai fi vizibil pe piata.",
  "myMaterials.archiveTitle": "Arhiveaza materialul?",
  "myMaterials.archived": "Material arhivat",
  "myMaterials.articles": "articole",
  "myMaterials.bulkUpload": "Incarcare in masa",
  "myMaterials.deleteDesc": "Materialul si tot inventarul asociat vor fi sterse permanent.",
  "myMaterials.deleteTitle": "Sterge materialul?",
  "myMaterials.deleted": "Material sters",
  "myMaterials.empty": "Niciun articol gasit",
  "myMaterials.emptyDesc": "Nu s-au publicat inca articole pe locatia ta.",
  "myMaterials.newArticle": "Articol nou",
  "myMaterials.noSite": "Contul tau nu are o locatie atribuita.",
  "myMaterials.noSiteDesc": "Contacteaza un administrator pentru a fi atribuit unei locatii.",
  "myMaterials.noSiteTitle": "Nicio locatie atribuita",
  "myMaterials.quantity": "Cant.",
  "myMaterials.searchPlaceholder": "Cauta articole...",
  "myMaterials.statusArchived": "Arhivat",
  "myMaterials.title": "Materialele locatiei mele",
  "myMaterials.value": "Valoare",
  "myMaterials.you": "Tu",
  "nav.analytics": "Analize",
  "nav.groupRequests": "Solicitari locatie",
  "nav.language": "Limba",
  "nav.matching": "Potrivire materiale",
  "nav.myGroup": "Grupul meu",
  "nav.myMaterials": "Articolele mele",
  "nav.scenario": "Scenariu",
  "nav.standardMaterials": "Materiale standard",
  "nav.switchGroup": "Schimba grupul",
  "nav.transactions": "Tranzactii",
  "pagination.next": "Urmatorul",
  "pagination.previous": "Anterior",
  "preset.applied": "Presetare \"{name}\" aplicata",
  "preset.applyFailed": "Eroare la aplicarea presetarii",
  "preset.delete": "Sterge",
  "preset.deleteConfirm": "Sterge presetarea?",
  "preset.deleteDescription": "Presetarea \"{name}\" va fi stearsa permanent.",
  "preset.deleteFailed": "Eroare la stergerea presetarii",
  "preset.deleted": "Presetare stearsa",
  "preset.filters": "filtre",
  "preset.filtersWillBeSaved": "filtre vor fi salvate",
  "preset.maxReached": "Maxim atins",
  "preset.name": "Numele presetarii",
  "preset.namePlaceholder": "ex. Filme FSC > 100mm",
  "preset.nameRequired": "Introdu un nume pentru presetare",
  "preset.newName": "Nume nou",
  "preset.noFiltersToSave": "Niciun filtru activ de salvat",
  "preset.noPresets": "Nicio presetare salvata",
  "preset.presets": "Presetari",
  "preset.rename": "Redenumeste",
  "preset.renameFailed": "Eroare la redenumirea presetarii",
  "preset.renamePreset": "Redenumeste presetarea",
  "preset.renamed": "Presetare redenumita",
  "preset.saveCurrentFilters": "Salveaza filtrele actuale",
  "preset.saveDescription": "Da un nume combinatiei tale de filtre pentru a o aplica rapid mai tarziu.",
  "preset.saveFailed": "Eroare la salvarea presetarii",
  "preset.saveHint": "Aplica filtre si salveaza-le",
  "preset.savePreset": "Salveaza presetare filtru",
  "preset.saved": "Presetare salvata",
  "preset.used": "presetari folosite",
  "scenario.applyChanges": "Aplica modificari",
  "scenario.autoApproved": "Auto-aprobat",
  "scenario.blocked": "Blocat",
  "scenario.currentSettings": "Setari actuale",
  "scenario.docsBlocked": "Docs blocate",
  "scenario.enabled": "Activat",
  "scenario.escalatedRequests": "Solicitari escaladate",
  "scenario.externalAccess": "Acces extern",
  "scenario.internalWindow": "In fereastra interna",
  "scenario.itemsAtRisk": "Articole la risc",
  "scenario.noChanges": "Ajusteaza setarile si apasa 'Previzualizare' pentru a vedea efectul",
  "scenario.pendingRequests": "Solicitari in asteptare",
  "scenario.preview": "Previzualizare impact",
  "scenario.previewResult": "Impact proiectat",
  "scenario.subtitle": "Previzualizarea impactului modificarilor de guvernanta inainte de aplicare",
  "scenario.title": "Analiza What-If a scenariilor",
  "scenario.valueAtRisk": "Valoare la risc",
  "scenario.whatIf": "Previzualizare What-If",
  "search.allMaterials": "Toate materialele",
  "search.filtering": "Se filtreaza...",
  "search.materialsFound": "materiale gasite",
  "search.resultsFor": "Rezultate pentru",
  "search.tryAdjusting": "Incearca sa ajustezi filtrele sau termenii de cautare",
  "sort.newestFirst": "Cele mai noi",
  "sort.oldestFirst": "Cele mai vechi",
  "sort.priceHighLow": "Pret: Descrescator",
  "sort.priceLowHigh": "Pret: Crescator",
  "sort.quantityHighLow": "Cantitate: Descrescator",
  "sort.sortBy": "Sorteaza dupa",
  "status.archived": "Arhivat",
  "status.available": "Disponibil",
  "status.documentation_missing": "Docs. lipsa",
  "status.pendingApproval": "Aprobare in asteptare",
  "admin.guideAuditSteps": ["Navigheaza la Admin > Jurnal de audit.", "Foloseste filtrul de tip entitate.", "Foloseste filtrul de actiune.", "Extinde 'Modificarile' pentru a vedea datele modificate.", "Foloseste paginarea pentru a naviga in istoric."],
  "admin.guideCategoriesSteps": ["Navigheaza la Admin > Categorii pentru a vedea arborele.", "Apasa 'Adauga categorie' pentru o categorie principala.", "Apasa '+' pe orice categorie pentru a adauga o subcategorie.", "Editeaza sau sterge categoriile existente.", "Categoriile pot fi reordonate prin campul de ordine."],
  "admin.guideDashboardSteps": ["Navigheaza la Dashboard.", "Verifica KPI-urile globale.", "Foloseste filtrul de locatie pentru metrici specifice.", "Descarca rapoarte PDF de sustenabilitate.", "Monitorizeaza materialele la risc."],
  "admin.guideExternalSteps": ["Companiile externe se inregistreaza prin formularul public (/register-external).", "Navigheaza la Admin > Companii externe pentru a revizui solicitarile.", "Apasa 'Aproba' pentru a activa compania.", "Apasa 'Respinge' pentru a refuza accesul.", "Companiile aprobate pot lista materialele lor.", "Apasa pe un rand al companiei pentru a vedea utilizatorii legati."],
  "admin.guideGettingStartedSteps": ["Creeaza grupul tau si cel putin o locatie sub Admin > Organizatii si Locatii.", "Incarca datele initiale cu butonul 'Incarca date' (doar o data pentru demo/test).", "Invita utilizatori prin linkul de inregistrare. Aproba utilizatorii noi sub Admin > Utilizatori.", "Configureaza modul de guvernanta preferat sub Admin > Scenarii.", "Incarca materiale prin pagina de import sau creeaza-le individual."],
  "admin.guideImportSteps": ["Navigheaza la pagina de import.", "Descarca modelul Excel.", "Completeaza datele si incarca fisierul.", "Verifica rezultatele validarii.", "Alege un mod de import.", "Executa importul."],
  "admin.guideNotificationsSteps": ["Navigheaza la Admin > Notificari.", "Verifica statisticile: total trimis, esuat si pe tip.", "Apasa 'Verifica acum' pentru a rula verificarea de escaladare.", "Rasfoieste istoricul notificarilor.", "Notificarile necesita o cheie API Resend configurata."],
  "admin.guideScenariosSteps": ["Selecteaza un mod: Echilibrat (implicit), Conservator, Agresiv (Cash) sau Mod Criza.", "Ajusteaza 'Fereastra interna' (zile in care materialele raman doar interne).", "Seteaza 'Zilele de escaladare' pentru notificari automate.", "Activeaza/dezactiveaza 'Extern activat' pentru a controla accesul extern.", "Activeaza/dezactiveaza 'Aprobare necesara' pentru aprobare automata sau manuala.", "Activeaza 'Documentatie stricta' pentru a bloca articolele fara fise tehnice."],
  "admin.guideUsersSteps": ["Navigheaza la Admin > Utilizatori pentru a vedea toti inregistratii.", "Utilizatorii in asteptare sunt marcati cu un indicator galben.", "Apasa 'Aproba' pentru a acorda acces complet la piata.", "Apasa 'Revoca' pentru a dezactiva temporar accesul.", "Administratorii sunt aprobati automat la inregistrare."],
  "admin.pendingRequests": "Solicitari in asteptare",
  "demo.badge": "Rezerva o demonstratie",
  "demo.company": "Companie",
  "demo.companyPlaceholder": "Numele companiei tale",
  "demo.ctaHero": "Rezerva o demonstratie",
  "demo.email": "E-mail de afaceri",
  "demo.emailPlaceholder": "nume@companie.ro",
  "demo.errorToast": "Eroare la trimiterea solicitarii. Incearca din nou.",
  "demo.message": "Mesaj (optional)",
  "demo.messagePlaceholder": "Spune-ne despre nevoile tale...",
  "demo.name": "Nume",
  "demo.namePlaceholder": "Numele tau complet",
  "demo.phone": "Telefon (optional)",
  "demo.phonePlaceholder": "+40 ...",
  "demo.point1": "Tur live al platformei",
  "demo.point2": "Adaptat la industria si nevoile tale",
  "demo.point3": "Fara obligatii — complet gratuit",
  "demo.privacy": "Respectam confidentialitatea ta. Datele tale vor fi folosite doar pentru a te contacta in legatura cu demonstratia.",
  "demo.requiredFields": "Completeaza toate campurile obligatorii.",
  "demo.sending": "Se trimite...",
  "demo.submit": "Solicita demonstratie",
  "demo.subtitle": "Rezerva o demonstratie gratuita si personalizata cu echipa noastra.",
  "demo.successDesc": "Solicitarea ta a fost primita. Echipa noastra te va contacta in 24 de ore.",
  "demo.successTitle": "Multumim!",
  "demo.successToast": "Solicitare de demonstratie trimisa cu succes!",
  "demo.title": "Vezi Surplify in actiune",
  "app.subtitle": "a face surplusul util",
  "auth.loginError": "E-mail sau parola invalide",
  "auth.loginSuccess": "Autentificare reusita!",
  "auth.passwordTooShort": "Parola trebuie sa aiba cel putin 6 caractere",
  "auth.passwordsNoMatch": "Parolele nu corespund",
  "auth.registerError": "Inregistrarea a esuat",
  "filter.allCategories": "Toate categoriile",
  "home.loginRequired": "Autentificati-va pentru a folosi lista de urmarire",
  "home.materialsCount": "materiale",
  "home.noMaterials": "Niciun material gasit.",
  "home.seedDescription": "Puteti incarca date exemplu pentru a incepe.",
  "home.seedError": "Eroare la incarcarea datelor",
  "home.seedSuccess": "Date incarcate cu succes! Se actualizeaza...",
  "home.seeding": "Se incarca...",
  "home.watchlistError": "Eroare la actualizarea listei de urmarire",
  "sort.dateAdded": "Data adaugarii",
  "sort.price": "Pret",
  "sort.quantity": "Cantitate",
  "admin.platformSettings": "Setări",
  "admin.resendEmail": "Retrimite e-mail",
  "guide.title": "Ajutor & Întrebări frecvente",
  "guide.subtitle": "Manual utilizator și răspunsuri la întrebări frecvente",
  "guide.searchPlaceholder": "Caută în manual și întrebări frecvente...",
  "guide.tabGuide": "Manual utilizator",
  "guide.tabFaq": "Întrebări frecvente",
  "guide.noResults": "Niciun rezultat pentru",
  "guide.topic": "subiect",
  "guide.topics": "subiecte",
  "home.hero.badge": "B2B Circular · Tipar și Ambalaje",
  "home.hero.verified": "Verificat UE",
  "home.hero.headlineA": "Reutilizează.",
  "home.hero.headlineB": "Repară.",
  "home.hero.headlineC": "Redistribuie.",
  "home.hero.subtitle": "Surplify este marketplace-ul B2B circular pentru industria tiparului și a ambalajelor — oferă o a doua viață materialelor excedentare, pieselor de schimb și mașinilor uzate. Fiecare tranzacție evită producția nouă, economisește CO₂ și păstrează capitalul de lucru.",
  "home.hero.impactPrefix": "Economisit împreună până acum:",
  "home.hero.impactSuffix": "de CO₂",
  "home.hero.searchPlaceholder": "Producător, nr. piesă, material, model…",
  "home.hero.searchBtn": "Caută",
  "home.hero.verticalMaterials": "Surplus",
  "home.hero.verticalSpareParts": "Piese de schimb",
  "home.hero.verticalMachines": "Mașini",
  "home.hero.verticalPaints": "Cerneluri & acoperiri",
  "home.hero.ctaPostWanted": "Publică o cerere de cumpărare",
  "home.hero.ctaForSellers": "Pentru vânzători",
  "home.hero.ctaGuide": "Ajutor & ghid",
  "home.hero.trustVies": "CIF verificat prin EU VIES",
  "home.hero.trustCompanies": "Conturi de firmă verificate",
  "home.hero.trustCircular": "Economie circulară",
  "home.newco.badge": "Nou pe Surplify?",
  "home.newco.title": "Compania ta pe marketplace-ul B2B în 3 pași",
  "home.newco.subtitle": "Material în surplus, reziduuri, vopsele, piese de schimb și mașini de tipar second-hand — totul pe o singură platformă. Începe gratuit, tranzacționează corect și documentează în conformitate cu REACH/CLP.",
  "home.newco.step1Title": "Creează-ți compania",
  "home.newco.step1Desc": "Nume companie, cod TVA, adresă — validat prin VIES",
  "home.newco.step2Title": "Creează primul tău anunț",
  "home.newco.step2Desc": "Material, vopsea, piesă sau mașină — completează formularul, gata",
  "home.newco.step3Title": "Primește cereri și vinde",
  "home.newco.step3Desc": "Comision doar la tranzacții reușite. Fără taxe de configurare.",
  "home.newco.ctaRegister": "Înregistrează-ți compania acum",
  "home.newco.ctaPartners": "Pentru parteneri și clienți mari",
  "home.newco.disclaimer": "Plan de start gratuit · Fără card de credit · Conform GDPR și B2B",
  "home.newco.whatYouGet": "Ce primești",
  "home.newco.freeTier": "În planul de start gratuit",
  "home.newco.feat1Label": "4 verticale de material",
  "home.newco.feat1Sub": "Materiale · Vopsele · Piese de schimb · Mașini",
  "home.newco.feat2Label": "Anunțuri nelimitate",
  "home.newco.feat2Sub": "Fără limite de cantitate pe planul standard",
  "home.newco.feat3Label": "Algoritm de potrivire",
  "home.newco.feat3Sub": "Cererile cumpărătorilor sunt asociate automat",
  "home.newco.feat4Label": "Conformitate REACH/CLP",
  "home.newco.feat4Sub": "Fișe de securitate și pictograme GHS integrate",
  "home.newco.feat5Label": "Raportare de sustenabilitate",
  "home.newco.feat5Sub": "Economiile de CO₂ sunt documentate automat",
  "home.newco.freeBadge": "Începe 100% gratuit",
  "home.pillar.materials.label": "Surplus",
  "home.pillar.materials.title": "Surplus & materiale",
  "home.pillar.materials.desc": "Folii, hârtie, role și semifinite — păstrate în circuit în loc să fie incinerate.",
  "home.pillar.materials.metric": "anunțuri active",
  "home.pillar.spareParts.label": "Piese de schimb",
  "home.pillar.spareParts.title": "Piese de schimb și module",
  "home.pillar.spareParts.desc": "Piese OEM reutilizate — fiecare componentă salvată evită o nouă extracție și producție.",
  "home.pillar.spareParts.metric": "noi",
  "home.pillar.machines.label": "Mașini",
  "home.pillar.machines.title": "Mașini de tipar",
  "home.pillar.machines.desc": "Presele uzate înlocuiesc cele noi — cu până la 80 % mai puțin CO₂.",
  "home.pillar.machines.metric": "disponibile",
  "home.pillar.paints.label": "Cerneluri & acoperiri",
  "home.pillar.paints.title": "Cerneluri, lacuri & aditivi",
  "home.pillar.paints.desc": "Cerneluri, lacuri și aditivi chimici excedentari — păstrați în producție în loc să fie tratați ca deșeuri periculoase.",
  "home.pillar.paints.metric": "în stoc",
  "home.sustain.liveImpact": "Impact în timp real",
  "home.sustain.co2": "CO₂ economisit",
  "home.sustain.redistributed": "redistribuit",
  "home.sustain.sites": "locații",
  "home.sustain.circular": "rată circulară",
  "home.sustain.atRisk": "la risc",
  "home.machines.label": "Vertical · Mașini",
  "home.machines.title": "Mașini de tipar uzate, pentru un al doilea ciclu de producție.",
  "home.machines.subtitle": "Fiecare presă uzată înlocuiește una nou-construită — cu o fracțiune de CO₂ și materii prime. Inspecție opțională, compatibilitate verificată.",
  "home.machines.seeAll": "Toate mașinile",
  "home.machines.emptyDesc": "Nicio mașină de tipar listată momentan.",
  "home.machines.emptyCreate": "Creează anunț",
  "home.spareParts.label": "Vertical · Piese de schimb",
  "home.spareParts.title": "Piese OEM — păstrate în circulație.",
  "home.spareParts.subtitle": "Stoc neutilizat, rezerve pentru obsolescență, linii dezafectate. Redirecționăm piesele în producție în loc de fier vechi.",
  "home.spareParts.seeAll": "Toate piesele",
  "home.spareParts.emptyDesc": "Nicio piesă listată momentan.",
  "home.spareParts.emptyCreate": "Creează primul anunț",
  "home.paints.label": "Vertical · Cerneluri & acoperiri",
  "home.paints.title": "Cerneluri, lacuri și aditivi excedentari — înapoi în mașină.",
  "home.paints.subtitle": "Nuanțe retrase, loturi rămase, stoc retras. Readucem chimicalele de tipar în producție în loc să plătim taxe de eliminare.",
  "home.paints.seeAll": "Toate cernelurile & acoperirile",
  "home.paints.emptyDesc": "Nicio cerneală, lac sau aditiv listat momentan.",
  "home.paints.emptyCreate": "Creează primul anunț",
  "home.materials.label": "Vertical · Surplus",
  "home.materials.title": "Surplus & supraproducție.",
  "home.materials.subtitle": "Stoc live din producții, golire de depozite și retururi de calitate — readus direct în industrie.",
  "home.trust.vies.title": "CIF UE VIES",
  "home.trust.vies.desc": "Verificare automată a codurilor TVA pentru fiecare companie înregistrată.",
  "home.trust.companies.title": "Companii verificate",
  "home.trust.companies.desc": "Doar conturile B2B verificate au acces complet la piață.",
  "home.trust.csv.title": "Import CSV în masă",
  "home.trust.csv.desc": "Listează mii de piese și materiale într-un singur upload.",
  "home.trust.circular.title": "Economie circulară",
  "home.trust.circular.desc": "Fiecare redistribuire evită producția nouă și reduce emisiile scope 3.",
  "machine.card.label": "Mașină de tipar",
  "machine.card.year": "An",
  "machine.card.hours": "h",
  "machine.card.width": "Lățime",
  "machine.card.price": "Preț",
  "sparePart.card.label": "Piesă de schimb",
  "sparePart.card.compatible": "Compatibil:",
  "sparePart.card.single": "Articol unic"
};

export default ro;
